import React, { Component } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { pathOr } from 'ramda';

import AempUserIcon from '../icons/aemp-user-icon';
import Eye from '../icons/eye-svg';

import PopUp from '../commons/component/popup';
import Recaptcha from '../commons/component/captcha/recaptcha';
import Input from '../commons/component/input';
import Radio from '../commons/component/aemp-radio';
import Button from '../commons/component/button';

import ForgotPasswordForm from './forgot-password-form';
import FacebookButton from './facebook-button';
import GoogleButton from './google-button';
import { PrivacyPolicy } from './styles';

import { getAllQueryParams, pushOrRedirect, setFocusById, isEmbedded } from '../commons/query';
import { safelySetCookie } from '../commons/cookie';
import { isQuiosque, isTelevendas } from '../commons/utils/sales-channel';

import { setUserEmail } from '../api/customer/login';
import { getCustomersList, getCustomersListFiltered } from '../api/restql/login-info';

import {
  getErrorMessageByErrorCode,
  getStepAfterLogin,
  isCustomerLocked,
  login2Step,
  login2StepAuthenticate
} from './entrar-action';

import config from '../generated/config';
import { dispatchErrorEvent } from '../api/account/authenticate';
import { sendFailMessage, sendSuccessfulyMessage } from '../commons/utils/post-message';
import AlertComponent from './alert-component';
import { dispatchMetric } from '../metrics';
import { getEventPayload } from '../metrics/metrics.selector';
import { addHotjarScript } from '../service/hotjar.helper';

const {
  facebookAppId,
  googleAppId,
  enableCaptchaOnLogin,
  enableGoogleLogin,
  enableFacebookLogin,
  show2stepLogin,
  url,
  enableNeedHelpOnLogin,
  showRegister
} = config;

const passwordTitle = () => {
  return `senha ${config.atBrandName}`;
};

const facebookLoginEnabled =
  enableFacebookLogin && facebookAppId && !(isQuiosque() || isTelevendas());
const googleLoginEnabled = googleAppId && enableGoogleLogin && !(isQuiosque() || isTelevendas());

const hasLoginGuestInParams = params =>
  Boolean(params.guest) || pathOr('', ['p'], params).includes('lg');

class Entrar2StepLogin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      popup: {
        isShowing: false,
        title: '',
        content: null
      },
      login: {
        showPassword: false,
        isSubmitting: false,
        defaultErrorMessage: 'e-mail ou senha incorretos',
        errorMessage: '',
        password: '',
        email: '',
        cnpjFilter: null
      },
      guestLogin: {
        isShowing: false,
        isSubmitting: false,
        defaultErrorMessage: 'número do pedido ou CPF incorretos',
        errorMessage: '',
        orderId: '',
        cpf: ''
      },
      cnpjList: [],
      selectedCnpj: '',
      filteredCnpjs: [],
      isLoadingCnpj: false,
      loginNextStep: false,
      customerData: {},
      filterValue: ''
    };
  }

  componentWillMount() {
    addHotjarScript();
  }

  isGuestLogin = () => {
    const params = getAllQueryParams();
    return hasLoginGuestInParams(params);
  };

  redirect(url) {
    return e => {
      e.preventDefault();
      pushOrRedirect(this.props.history.push, {
        url: url,
        push: true
      });
    };
  }

  loggedWithoutCnpjSelected = () => {
    const { cnpjList, selectedCnpj } = this.state;
    if (cnpjList.length > 0 && !selectedCnpj) {
      return true;
    }
    return false;
  };

  render() {
    const {
      login,
      cnpjList,
      selectedCnpj,
      filteredCnpjs,
      popup,
      filterValue,
      isLoading
    } = this.state;
    const hasCompaniesToChoose = !!cnpjList.length;
    const hasErrors = !!login.errorMessage;

    return (
      <div className="entrar__wrapper">
        <h1 className="entrar-title">
          <AempUserIcon />
          <span>Login do Cliente</span>
        </h1>
        {hasCompaniesToChoose ? (
          <div className="aemp-login-subtitle">
            <p>
              sua conta está associada a mais de uma (1) empresa. por favor, selecione uma empresa
              para seguir para minha conta.
            </p>
          </div>
        ) : null}
        {!!hasErrors && (
          <AlertComponent>
            <p className="safeParagraph">revise seu e-mail e senha</p>
          </AlertComponent>
        )}
        <form onSubmit={this.selectCnpj}>
          {!hasCompaniesToChoose ? (
            <div>
              <label
                className={`entrar-inputBlock --column${hasErrors ? ' --error' : ''}`}
                id="emai"
              >
                <label className="entrar-inputLabel" htmlFor="email-input">
                  e-mail
                </label>
                <Input
                  id="email-input"
                  placeholder="ex: joaodasilva@gmail.com"
                  className="entrar-input form-control --aempStyles"
                  data-page="login"
                  data-form="login"
                  name="email"
                  type="email"
                  required
                  value={login.email}
                  onChange={this.handleChange('login')}
                  disabled={login.isSubmitting || hasCompaniesToChoose}
                  onBlur={
                    config.shouldSetUserEmailCookie
                      ? e => safelySetCookie(setUserEmail, e.target.value)
                      : null
                  }
                />
              </label>
              <label
                className={`entrar-inputBlock --column --passwordInput${
                  hasErrors ? ' --error' : ''
                }`}
                id="password"
              >
                <label className="entrar-inputLabel --aempStyles" htmlFor="password-input">
                  {passwordTitle()}
                </label>
                <div className="entrar-input__wrapper">
                  <Input
                    id="password-input"
                    name="password"
                    data-page="login"
                    data-form="login"
                    className="entrar-input --hasAddon form-control --aempStyles"
                    type={login.showPassword ? 'text' : 'password'}
                    autoComplete={false}
                    placeholder="********"
                    minLength={4}
                    required
                    value={login.password}
                    onChange={this.handleChange('login')}
                    disabled={login.isSubmitting}
                  />
                  <span onClick={this.toggleShowPassword} className="entrar-inputAddon">
                    <Eye on={!login.showPassword} />
                  </span>
                </div>
              </label>
              {hasErrors && <span>não lembra sua senha? </span>}
              <a href="/simple-login/esqueci-senha" className="recover-password-link">
                recuperar senha
              </a>
            </div>
          ) : (
            <div className="inputGroup" id="cnpj">
              <label className={`entrar-inputBlock --column${hasErrors ? ' --error' : ''}`}>
                <label className="entrar-inputLabel">e-mail:</label>
                <div className="addonWrapper">
                  <Input
                    className="entrar-input form-control --aempStyles"
                    value={login.email}
                    disabled
                  />
                  <div className="inputText-addOn">
                    <span className="changeDocument" onClick={this.goBack}>
                      trocar
                    </span>
                  </div>
                </div>
              </label>
              <label className="inputGroup-label" htmlFor="cnpj-filter-input">
                digite ou selecione o cnpj:
              </label>
              <div className="simple-box">
                <div className="entrar-input-wrapper">
                  <Input
                    id="cnpj-filter-input"
                    placeholder="filtre pelo cnpj(completo) ou nome da filial"
                    className="entrar-input entrar-2step form-control --aempStyles --searchIcon"
                    name="cnpjFilter"
                    onChange={event => {
                      this.searchForCnpj(event);
                    }}
                  />
                </div>
                <div className="documents-wrapper">
                  {filteredCnpjs.length ? (
                    filteredCnpjs.map(emp => {
                      return (
                        <Radio
                          key={emp.id}
                          className="inputGroup-radio"
                          name="cnpj"
                          value={emp.id}
                          onClick={() => this.handleRadio(emp.id)}
                          checked={emp.id === selectedCnpj}
                          text={`${emp.type.pj.corporateName}`}
                          description={`${emp.type.pj.cnpj}`}
                          filterValue={filterValue}
                          data-form="login"
                          data-page="login"
                        />
                      );
                    })
                  ) : (
                    <p className="document-not-found">sem resultados</p>
                  )}
                </div>
              </div>
            </div>
          )}
          <div className="divisor is-3" />

          <div className="login-buttons-wrapper">
            <Button
              id="login-button"
              primary
              disabled={
                login.isFormSubmitting || this.loggedWithoutCnpjSelected() || isLoading || hasErrors
              }
              loading={login.isFormSubmitting || isLoading}
              className="entrar-button --aempStyles"
            >
              {hasCompaniesToChoose ? 'entrar' : 'continuar'}
            </Button>
            {hasCompaniesToChoose && (
              <Button
                loading={login.isFormSubmitting}
                className="button-ghost"
                type="button"
                onClick={this.goBack}
              >
                voltar
              </Button>
            )}
          </div>
        </form>
        {facebookLoginEnabled && (
          <p className="divisor is-3">
            <span>ou</span>
          </p>
        )}
        {facebookLoginEnabled && <FacebookButton />}
        {googleLoginEnabled && <p className="divisor is-3" />}
        {googleLoginEnabled && <GoogleButton />}
        <PopUp isOpened={popup.isShowing} onClose={this.closePopUp} title={popup.title}>
          {() => popup.content}
        </PopUp>
        {enableCaptchaOnLogin && <Recaptcha ref={ref => (this.captcha = ref)} />}
        {!hasCompaniesToChoose && (
          <div>
            <div className="divisor is-3">
              <span>ou</span>
            </div>
            {this.showRegisterLink()}
          </div>
        )}
        <div className="divisor is-3" />
        {this.showNeedHelp()}
        <PrivacyPolicy>
          ao continuar com o acesso, você concorda com a nossa{' '}
          <a target="_blank" rel="noopener noreferrer" href={url.privacyPolicy}>
            Política de Privacidade
          </a>
        </PrivacyPolicy>
      </div>
    );
  }

  handleLogin = async (customerId, customerData) => {
    this.setState({ isLoading: true });

    const { token: buyerToken, b2wUid, status } = customerData;

    const token = {
      token: buyerToken,
      id: customerId,
      b2wUid,
      status
    };
    const type = 'B2W';

    try {
      const authentication = await login2StepAuthenticate({ token, type });

      if (isEmbedded()) {
        sendSuccessfulyMessage();
      } else {
        const url = getStepAfterLogin(authentication);
        pushOrRedirect(this.props.history.push, url);
      }
      this.setState({ isLoading: false });
      return authentication;
    } catch (error) {
      this.setState({ isLoading: false });
      console.error('2 step login Error: ', error);
    }
  };

  selectCnpj = async event => {
    const { login: loginState, selectedCnpj, customerData } = this.state;
    event.preventDefault();

    if (selectedCnpj) {
      await this.handleLogin(selectedCnpj, customerData);
      return;
    }

    try {
      this.setState({ isLoading: true });

      const captchaResponse = enableCaptchaOnLogin ? await this.captcha.getResponse() : '';

      const { email, password } = loginState;
      const is2StepLogin = show2stepLogin;
      const authenticationInfo = { email, password, captchaResponse, is2StepLogin };

      const authentication = await login2Step(authenticationInfo);

      const customersCnpjList = await getCustomersList(authentication.token);
      const cnpjList = pathOr([], ['customers'], customersCnpjList);

      if (cnpjList.length === 1) {
        const customerId = cnpjList[0].id || '';
        await this.handleLogin(customerId, authentication.token);
        return;
      }

      this.resetErrors('login');
      this.setState({
        cnpjList,
        filteredCnpjs: cnpjList,
        customerData: authentication.token,
        loginNextStep: true,
        isLoading: false
      });
    } catch (error) {
      this.captcha.reset();
      this.setState({ isLoading: false });
      dispatchErrorEvent(error);
      this.turnLoadingOff('login');
      this.handleError('login', 'email')(error);
      sendFailMessage(error);
    }
  };

  goBack = event => {
    event.preventDefault();
    pushOrRedirect(this.props.history.push, {
      url: url.login
    });
  };

  handleError = (formName, idToBeFocused) => ({ errorCode }) => {
    setFocusById(idToBeFocused);
    this.turnLoadingOff(formName);
    const defaultErrorMessage = this.state[formName].defaultErrorMessage;

    if (isCustomerLocked(errorCode)) {
      this.showRetrievePasswordPopUp();
    } else {
      this.setState(state => ({
        ...state,
        [formName]: {
          ...state[formName],
          errorMessage: getErrorMessageByErrorCode(errorCode, defaultErrorMessage)
        }
      }));
    }
  };

  resetErrors = formName => {
    this.setState(state => ({
      ...state,
      [formName]: {
        ...state[formName],
        errorMessage: ''
      }
    }));
  };

  turnLoadingOff = formName => {
    this.setState(state => ({
      ...state,
      [formName]: {
        ...state[formName],
        isSubmitting: false
      }
    }));
  };

  searchForCnpj = async event => {
    try {
      const { customerData, cnpjList } = this.state;
      const { value: filterValue } = event.target;
      this.setState({ filterValue, selectedCnpj: '' });

      if (filterValue === '') {
        return this.setState({ filteredCnpjs: cnpjList });
      }

      if (filterValue.length > 0) {
        const filteredCnpjs = cnpjList.filter(customer => {
          const filialName = customer.type.pj.corporateName.toLowerCase();
          const cnpjNumber = customer.type.pj.cnpj.toLowerCase();
          const cnpjFilter = filterValue.toLowerCase();

          return filialName.includes(cnpjFilter) || cnpjNumber.includes(cnpjFilter);
        });

        if (filteredCnpjs.length) {
          return this.setState({ filteredCnpjs });
        }

        if (!filteredCnpjs.length && filterValue.replaceAll(/[^0-9]/gi, '').length === 14) {
          const customersCnpjList = await getCustomersListFiltered({
            ...customerData,
            document: filterValue.replaceAll(/[^0-9]/gi, '')
          });
          const cnpjList = pathOr([], ['customers'], customersCnpjList);

          return this.setState({ filteredCnpjs: cnpjList, selectedCnpj: cnpjList[0].id });
        }
      }

      return this.setState({ filteredCnpjs: [] });
    } catch (error) {
      console.error('Search: ', error);
      return [];
    }
  };

  showRegisterLink = () => {
    return this.isGuestLogin() ? (
      <p className="cadastrar-link">
        Comprou sem cadastro? <span onClick={this.openGuestLogin}>Acompanhe seu pedido aqui</span>
      </p>
    ) : (
      showRegister && (
        <p className="cadastrar-link">
          não tem cadastro?{' '}
          <Link
            to={`/cadastro/comprador${this.props.location.search}`}
            onClick={() =>
              dispatchMetric('event_login', {
                payload: getEventPayload({
                  event: 'event_login',
                  eventCategory: 'login',
                  eventAction: 'cadastrar',
                  eventLabel: undefined
                })
              })
            }
          >
            Cadastre-se
          </Link>
        </p>
      )
    );
  };

  showGuestRegisterLink = () => {
    if (isQuiosque()) {
      return (
        <p className="cadastrar-link">
          Ou cadastre-se como{' '}
          <Link to={`/cadastro/visitante${this.props.location.search}`}>visitante</Link>
        </p>
      );
    }
  };

  showNeedHelp = () => {
    if (enableNeedHelpOnLogin) {
      return (
        <p className="help-text">
          está tendo dificuldade para entrar?{' '}
          <a
            href={url.needHelpUrl}
            rel="noopener noreferrer"
            target="_blank"
            onClick={() =>
              dispatchMetric('event_login', {
                payload: getEventPayload({
                  event: 'event_login',
                  eventCategory: 'login',
                  eventAction: 'preciso-de-ajuda',
                  eventLabel: undefined
                })
              })
            }
          >
            preciso de ajuda
          </a>
        </p>
      );
    }
  };

  toggleShowPassword = () => {
    this.setState(state => ({
      ...state,
      login: {
        ...state.login,
        showPassword: !state.login.showPassword
      }
    }));
  };

  showPopUp = (title, content) => {
    this.setState({ popup: { isShowing: true, title, content } });
  };

  closePopUp = () => {
    this.setState({ popup: { isShowing: false, title: '', content: null } });
  };

  showRetrievePasswordPopUp = () => {
    const title = 'Trocar a senha';
    const content = (
      <ForgotPasswordForm
        email={this.state.email}
        onSuccess={this.showEmailSentPopUp}
        closePopUp={this.closePopUp}
      />
    );
    this.showPopUp(title, content);
  };

  showEmailSentPopUp = email => {
    const title = 'E-mail enviado';
    const content = (
      <span>
        Enviamos um e-mail para <strong>{email}</strong> com as instruções e o link para você trocar
        a senha. Caso você não receba o e-mail em alguns minutos, verifique a sua caixa de spam ou
        repita o processo.
      </span>
    );
    this.showPopUp(title, content);
  };

  handleChange = (formName, transformValue = v => v) => ({ target }) => {
    this.resetErrors(formName);
    this.setState(state => ({
      ...state,
      [formName]: {
        ...state[formName],
        [target.name]: transformValue(target.value)
      }
    }));
  };

  handleRadio = customerId => {
    this.setState({ selectedCnpj: customerId });
  };
}

export default withRouter(Entrar2StepLogin);
